import CONSTANTS from 'src/utils/constants';
import { WorksheetStatus } from 'src/models/multidimensional-allocation/MultiAllocationSheetData';
import { DerivedAllocationSheetData } from 'src/models/derived-allocation-sheet/DerivedAllocationSheet';
import { DatasetRecord } from 'src/models/tp-allocation/DatasetRecord';
import WorksheetTotal from 'src/models/tp-allocation/WorksheetTotal';

/** State of the derived allocation sheet builder page. */
export interface DerivedAllocationSheetBuilderState {
    sheet: DerivedAllocationSheetData | null;
    availableVersions: number[];
    loading: boolean;
    error?: string;
    viewMode: string;
    /** Saved Step 1 rows, read by the later steps for formula suggestions. */
    dataSources: DatasetRecord[];
    /** Step 2 rows, read by Step 3. */
    totals: WorksheetTotal[];
    /** Incremented to refetch the sheet header after a write. */
    sheetRefreshToken: number;
    /** Incremented to refetch Step 2 after a Step 1 row is renamed. */
    totalsRefreshToken: number;
    /** Steps with unsaved rows or a save in flight; another version cannot be opened until they are saved. */
    unsavedSteps: number[];
    /** True while an Execute run of the draft is in progress. */
    executing: boolean;
    /** Incremented after an Execute run, to reload the steps with the run's values. */
    stepsRevision: number;
}

export const initialState: DerivedAllocationSheetBuilderState = {
    sheet: null,
    availableVersions: [],
    loading: true,
    viewMode: CONSTANTS.VIEW_MODE.READ_ONLY,
    dataSources: [],
    totals: [],
    sheetRefreshToken: 0,
    totalsRefreshToken: 0,
    unsavedSteps: [],
    executing: false,
    stepsRevision: 0,
};

export interface DeriveDasViewModeArgs {
    canEdit: boolean;
    status?: WorksheetStatus;
    sheetVersion?: number;
    executing?: boolean;
}

/**
 * View mode of the builder. Only the draft version in DRAFT_IN_PROGRESS can be edited, and derived
 * allocation sheets have no edit lock:
 * 1. no edit permission: FROZEN
 * 2. any other status or version, or a run in progress (an edit during it fails the run): READ_ONLY
 * 3. otherwise EDITABLE
 */
export function deriveDasViewMode(args: DeriveDasViewModeArgs): string {
    const { canEdit, status, sheetVersion, executing } = args;
    if (!canEdit) {
        return CONSTANTS.VIEW_MODE.FROZEN;
    }
    if (status !== 'DRAFT_IN_PROGRESS' || sheetVersion !== CONSTANTS.CALCULATION_VERSIONS.DRAFT_VERSION || executing) {
        return CONSTANTS.VIEW_MODE.READ_ONLY;
    }
    return CONSTANTS.VIEW_MODE.EDITABLE;
}
